import React from 'react';

import {
  currencyUtil,
  LabelledText
} from 'modules/layer00';

import { BaseWidget } from 'modules/layer01';
import { Typography } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);



  return (
    <BaseWidget.FC title="Payment Information">
      {!queryTuple.data.paymentInformation && (
        <Typography>No Payment Information</Typography>
      )}

      {queryTuple.data.paymentInformation && (
        <>
          <LabelledText.FC
            title="Payment Method"
            text={queryTuple.data.paymentInformation?.paymentMethod} />

          <LabelledText.FC
            title="Sub Total"
            text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.subTotalCents)} />

          <LabelledText.FC
            title="Shipping and Handling"
            text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.shippingTotalCents)} />

          {queryTuple.data.paymentInformation.feeTotalCents.gt(0) && (
            <LabelledText.FC
              title="Fee Total"
              text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.feeTotalCents)} />
          )}

          <LabelledText.FC
            title="Tax"
            text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.taxTotalCents)} />

          {queryTuple.data.paymentInformation.discountTotalCents.gt(0) && (
            <LabelledText.FC
              title="Discount"
              text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.discountTotalCents)} />
          )}

          <LabelledText.FC
            title="Total"
            text={currencyUtil.convertBigCentsToDollars(queryTuple.data.paymentInformation.totalCents)} />
        </>
      )}
    </BaseWidget.FC>
  );
};
